import withLazyImport from '../../../common/hoc/with-lazy-import';

export default withLazyImport(() =>
  import(
    /* webpackChunkName: "post-editor" */
    './post-editor'
  ),
);
